<template>
  <div id="app">
    <router-view></router-view>
  </div>
    
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Noto+Sans+TC:wght@500;700;900&family=Roboto:wght@400;500;700;900&display=swap');
html, #app {
  height: 100%; }
* {
  box-sizing: border-box;
  /* margin: 0; */
  padding: 0;
}
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang TC", "LiHei Pro", "Hiragino Sans GB", "Microsoft JhengHei", "微軟正黑體", Arial ,sans-serif;
  height: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  color: #333;
  background-color: #fdfdfd;
  margin: 0; }

p, span, h1, h2, h3, h4, h5, h6, label, li {
  font-size: 16px;
  font-weight: normal; }
  @media (min-width: 640px) {
    p, span, h1, h2, h3, h4, h5, h6, label, li {
      font-size: 18px; } }
.font-r {
    font-family: 'Roboto', sans-serif;
}
img {
  width: 100%;
  max-width: 100%;
  height: auto; }

a {
  color: #333;
  text-decoration: none !important; }

header {
  height: 62px;
  background-color: #100316;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center; }
  header img {
    height: 60%;
    width: auto; }

.container {
  max-width: 540px;
  margin: 0 auto;
  /* min-height: 100%; */
  text-align: center;
  padding: 10px 0 0 0; }
button {
  border-radius: 0; }
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color; }

input, button, select, optgroup, textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button, input {
  overflow: visible; }

button {
  text-transform: none; }

select {
  text-transform: none;
  word-wrap: normal; }

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button; }

button:not(:disabled), [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled) {
  cursor: pointer; }

button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"], input[type="checkbox"] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0; }

input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"] {
  -webkit-appearance: listbox; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }
.d-none {
  display: none; }
.animated {
  -webkit-animation-duration: 0.5s !important;
  animation-duration: 0.5s !important; }
  .font-r {
    font-family: 'Roboto', sans-serif;
  }
</style>